import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppNew from './AppNew';
import { AirportsProvider } from './contexts/AirportsContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AirportsProvider>
      <AppNew />
    </AirportsProvider>
  </React.StrictMode>
);
